import {NgModule} from '@angular/core';
import {FileSliderComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgForOf, NgIf, NgStyle} from '@angular/common';
import {IconComponentModule} from '../icon/item.module';
import {GalleryModalComponentModule} from '../../shared/galleryModal/item.module';
import {BlockElementLabelComponentModule} from 'app/components/blocks/components/blockElementLabel/item.module';

@NgModule({
    imports: [
        IonicModule,
        NgStyle,
        NgClass,
        NgIf,
        IconComponentModule,
        NgForOf,
        GalleryModalComponentModule,
        BlockElementLabelComponentModule,
    ],
  exports: [
    FileSliderComponent
  ],
  declarations: [FileSliderComponent],
  providers: [],
})
export class FileSliderComponentModule {
}
